module.exports = __webpack_public_path__ + "img/waveform.7c634811.svg";